module.exports = __webpack_public_path__ + "media/bootstrap-icons/pencil-e3c555fd.svg";